<div class="container content-box module-content">


    <!-- EDIT PAST THIS LINE -->


    <h2>Sample Credit Report Order</h2>
    <p>One way that a free credit report can be obtained is by sending a letter to a credit reporting bureau. The sample letter is made up. When you write your letter, use your personal information.</p>


    <!-- DON'T EDIT PAST THIS LINE -->


    <div class="text-center">
        <button type="button" class="btn waves-dark w-25" (click)="downloadOrder(); content.downloaded = true" [class.invalid]="content.validate && !content.downloaded">Download Handout</button>

        <div class="invalid-feedback d-block" *ngIf="content.validate && !content.downloaded">
          Download and review handout first.
        </div>
    </div>

</div>

<div class="container navigate-buttons">
    <button type="button" class="btn waves-dark w-25" (click)="goBack($event)"><i class="fas fa-angle-left mr-3"></i>{{backTitle}}</button>
    <button type="button" class="btn waves-dark w-25" (click)="previewByAdmin || !delay || content.downloaded ? goNext($event) : content.validate = true" [delay-click]="delay ? 20 : 0" [delay-tooltip]="true">{{nextTitle}}<i class="fas fa-angle-right ml-3"></i></button>
</div>
